import axios from 'axios'
import store from '../store'

const baseUrl = '/oneview/bff/v1/api';
const nsBaseUrl = '/oneview/bff/v1/nsapi';
export default {
	loginUser(ssoTokenData) {
		return axios.post(baseUrl + '/tWebUtils/loginBySSO', ssoTokenData)
		.then(response => {
					return response.data
				}
		)
	},
	confirmTariffs(jwt, data) {
		return axios.post(baseUrl + '/migration/tariffOrders', data, {headers: {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json'}})
		.then(response => {
					store.commit('SET_RESULT_SIMPLE_INFO', response.data)
					return response.data
				}
		)
	},
	getBasicInfo(token) {
		return axios.get(baseUrl + '/migration/eligibilityCheck', {headers: {Authorization: "Bearer " + token, 'Content-Type': 'application/json'}})
		.then(response => {
					return response.data
				}
		)
	},
	getSubscriberInfo(jwt, data) {
		return axios.post(baseUrl + '/migration/calculate', data, {headers: {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json'}})
		.then(response => {
					const resultData = {
						data: response.data,
						subscriberId: data.subscriberId
					}
					store.commit('SET_SUBSCRIBER_INFO', resultData)
					return response.data
				}
		)
	},
	setLanguage(language) {
		axios.defaults.headers.common['x-oneapplang'] = language
	},
	/*
	Login user
	 */

	loginByUsernameAndPassword(usernameP, passwordP) {
		const data = {
			username: usernameP,
			password: passwordP
		}
		return axios.post(nsBaseUrl + '/login/byname', data, {'Content-Type': 'application/json'})
		.then((response => {
					return response.data
				})
		)
	},

	createOtp(service) {
		const data = {
			serviceId: service

		}
		return axios.post(nsBaseUrl + '/login/byotp/create', data, {'Content-Type': 'application/json'})
		.then((response => {

					return response.data;
				})
		)
	},

	loginByOtpAndService(pin, service) {
		const data = {
			serviceId: service,
			otp: pin

		}

		return axios.put(nsBaseUrl + '/login/byotp', data, {'Content-Type': 'application/json'})
		.then((response => {
					return response.data
				})
		)
	},

	loginByCookie(cookie) {
		const data = {
			cookieValue: cookie
		}
		return axios.post(nsBaseUrl + '/login/bycookie', data, {'Content-Type': 'application/json'})
		.then((response => {
					return response.data
				})
		)
	},

	logout(jwt, ssoId) {
		let headers;
		if (ssoId != undefined && ssoId.length > 0) {
			console.log('ssoid')
			headers = {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json', 'x-cvalue': "ssoId="+ssoId}
		} else {
			headers = {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json', 'x-cvalue': "ssoId=joudajede"}
		}
		axios.delete(baseUrl + '/login', {headers: headers})
	},

	getLinkOnEshopWithId(linkId, jwt) {
		let headers;
		if (jwt == undefined || jwt == null || jwt.length  < 1) {
			headers = {'Content-Type': 'application/json'}
		} else {
			headers = {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json'}
		}
		return axios.get(nsBaseUrl + '/tWebUtils/sso/url?urlid=' + linkId, {headers: headers} )
			.then((res => {
					return res.data.url;
				}
			))

	},

	getLinkOnEshopWithoutId(jwt) {
		let headers;
		if (jwt == undefined ||  jwt == null || jwt.length  < 1) {
			headers = {'Content-Type': 'application/json'}
		} else {
			headers = {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json'}
		}
		return axios.get(nsBaseUrl + '/tWebUtils/sso/url', {headers: headers})
			.then((res => {
					return res.data.url;
				}
			))

	}
}
